
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Äganderättens avgång</h5>

    <h6 style="font-weight: 500;">Process</h6>
    <h6>{$selectedItem?.resignation_of_ownership?.process ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Tidbegränsning</h6>
    <h6>{$selectedItem?.resignation_of_ownership?.time_restrictions ?? "Uppgifter saknas"}</h6>
</div>